import api from './api';

export interface ImpuestoReadDto {
  codigoImpuesto: string;
  descripcion: string;
  tipo?: string | null;
  ctaCtable?: number | null;
  basadoen?: number | null;
  valor?: number | null;
  codigoSiap?: string | null;
  tipoImpuesto?: string | null;
  montoGravMin?: number | null;
  montoGravMax?: number | null;
  montoImpuestoMin?: number | null;
  montoImpuestoMax?: number | null;
  idJurisdiccion?: string | null;
  idRegimen?: string | null;
}

export interface ImpuestoSearchParams {
  searchTerm?: string;
  pageNumber?: number;
  pageSize?: number;
}

export interface ImpuestoPagedResult {
  items: ImpuestoReadDto[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

export interface CreateImpuestoDto {
  codigoImpuesto: string;
  descripcion: string;
  tipo?: string | null;
  ctaCtable?: number | null;
  basadoen?: number | null;
  valor?: number | null;
  codigoSiap?: string | null;
  tipoImpuesto?: string | null;
  montoGravMin?: number | null;
  montoGravMax?: number | null;
  montoImpuestoMin?: number | null;
  montoImpuestoMax?: number | null;
  idJurisdiccion?: string | null;
  idRegimen?: string | null;
}

export interface UpdateImpuestoDto {
  descripcion: string;
  tipo?: string | null;
  ctaCtable?: number | null;
  basadoen?: number | null;
  valor?: number | null;
  codigoSiap?: string | null;
  tipoImpuesto?: string | null;
  montoGravMin?: number | null;
  montoGravMax?: number | null;
  montoImpuestoMin?: number | null;
  montoImpuestoMax?: number | null;
  idJurisdiccion?: string | null;
  idRegimen?: string | null;
}

const impuestoService = {
  getImpuestos: async (params: ImpuestoSearchParams): Promise<ImpuestoPagedResult> => {
    const resp = await api.get('/api/Impuestos', {
      params: {
        SearchTerm: params.searchTerm || undefined,
        PageNumber: params.pageNumber ?? 1,
        PageSize: params.pageSize ?? 10
      }
    });
    const data = resp.data;
    if (data && typeof data === 'object' && 'items' in data) {
      return data as ImpuestoPagedResult;
    }
    return {
      items: [],
      totalCount: 0,
      pageNumber: params.pageNumber ?? 1,
      pageSize: params.pageSize ?? 10,
      totalPages: 0
    };
  },

  getImpuesto: async (codigoImpuesto: string): Promise<ImpuestoReadDto> => {
    const encoded = encodeURIComponent(codigoImpuesto.trim());
    const resp = await api.get(`/api/Impuestos/${encoded}`);
    return resp.data as ImpuestoReadDto;
  },

  createImpuesto: async (dto: CreateImpuestoDto): Promise<ImpuestoReadDto> => {
    const response = await api.post<ImpuestoReadDto>('/api/Impuestos', dto);
    return response.data;
  },

  updateImpuesto: async (codigoImpuesto: string, dto: UpdateImpuestoDto): Promise<void> => {
    const encoded = encodeURIComponent(codigoImpuesto.trim());
    await api.put(`/api/Impuestos/${encoded}`, dto);
  },

  deleteImpuesto: async (codigoImpuesto: string): Promise<void> => {
    const encoded = encodeURIComponent(codigoImpuesto.trim());
    await api.delete(`/api/Impuestos/${encoded}`);
  }
};

export default impuestoService;
